/**
 * Der Block „Demnächst kündbar" im Reiter *Energie* (Spec 46c, „Beide Clients —
 * Reiter Energie"): Verträge mit „kündbar bis" in den nächsten 60 Tagen, vom
 * Server sortiert und gedeckelt (`MeterList.cancellable`). Je Zeile die
 * Kalenderkachel (`DateTile`), `title_display` mit `detail_display` und rechts
 * die Resttage-Kapsel in Statustönung. Kein 3-px-Rand, kein Punkt.
 *
 * Alle Wörter und Zahlen kommen vom Server; die Zeile führt zum Zählerdetail
 * (`?zaehler=`). Ohne Einträge entfällt der Block ganz (kein Leertext).
 */

import { Link } from '@tanstack/react-router'

import { DateTile } from '@/components/DateTile'
import type { CancellableContract } from '@/features/energy/api'

interface CancellableListProps {
  readonly items: readonly CancellableContract[]
  /** `haus` der URL — bleibt beim Öffnen des Details erhalten. */
  readonly house: string | undefined
}

export function CancellableList({ items, house }: CancellableListProps) {
  if (items.length === 0) return null

  return (
    <section data-testid="energy-cancellable" aria-labelledby="energy-cancellable-title" className="border-border border-b">
      <h2
        id="energy-cancellable-title"
        data-testid="energy-cancellable-title"
        className="text-section font-(--font-weight-section) text-text px-(--page-x) pt-3 pb-1"
      >
        Demnächst kündbar
      </h2>
      <ul>
        {items.map((contract) => (
          <li key={contract.contract_id}>
            <Link
              to="/energie"
              search={{ haus: house, zaehler: contract.meter.id }}
              data-testid={`energy-cancellable-row-${contract.contract_id}`}
              className="hover:bg-bg flex min-h-(--row-h) items-center gap-3 px-(--page-x) py-2 transition-colors duration-(--duration-fast) ease-(--ease-out)"
            >
              <DateTile
                testId={`energy-cancellable-tile-${contract.contract_id}`}
                month={contract.month_tile_display}
                day={contract.day_tile_display}
              />
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-body text-text font-semibold">{contract.title_display}</span>
                <span className="text-label text-muted">{contract.detail_display}</span>
              </span>
              <span
                data-numeric
                data-testid={`energy-cancellable-remaining-${contract.contract_id}`}
                className="bg-status-partial-surface text-status-partial-text text-label shrink-0 rounded-full px-2 py-0.5 font-semibold whitespace-nowrap"
              >
                {contract.remaining_display}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
